<template>
    <div v-if="active.expirationDate">
        <a :href="active.link" :aria-label="'Go to ' + active.expirationDate">
            {{ active.expirationDate }}
        </a>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const active = computed(() => {
    return props.formatted[props.label] ?? {};
});
</script>
